import { nextTick, toValue, watch } from "vue";

export function useScrollToCard(cardsPaneRef, tokenRef) {
  const findCard = async () => {
    await nextTick();
    await nextTick();
    const token = toValue(tokenRef);
    if (!token) return null;
    return document.getElementById(`nav-menu-item-${token}`);
  };

  const scrollToCard = async () => {
    const card = await findCard();
    card?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  watch(
    () => toValue(tokenRef),
    async () => {
      const card = await findCard();
      card?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    },
  );

  return { scrollToCard };
}
